import Http from '../api/http';

export default class CloudFile extends Http {
  constructor() {
    super();
  }
  // 嗨探云盘删除
  cloud_delete() {
    return super.post('  cloud/delete', ...arguments);
  }
  // 嗨探云盘详情
  cloud_detail() {
    return super.post('cloud/detail', ...arguments);
  }
  // 嗨探云盘列表
  cloud_list() {
    return super.post('cloud/list', ...arguments);
  }
  // 嗨探云盘列表v2
  cloud_listV2() {
    return super.post('cloud/listV2', ...arguments);
  }
  // 嗨探云盘删除
  cloud_update() {
    return super.post('cloud/update', ...arguments);
  }
  // 嗨探云盘上传报告 建立引用
  cloud_uploadReport() {
    return super.post('cloud/uploadReport', ...arguments);
  }
  // 解除引用
  cloud_unbind() {
    return super.post('cloud/unbind', ...arguments);
  }
  // 根据报告id 或考核点id 查询是否有引用文件
  cloud_queryByRefId() {
    return super.post('cloud/queryByRefId', ...arguments);
  }
  // 上传到云盘 测试用
  cloud_upload() {
    return super.post('cloud/upload', ...arguments);
  }
}
